/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetAllGroupedRegions() {
  const response = await $.soap({
    body: {
      GetAllGroupedRegions: {
        $xmlns: 'http://dla.mil/ems/bpm/lookup'
      }
    },
    blueprintArrays: ['GetAllGroupedRegionsResponse.Groups.GroupedRegion'],
    blueprint: {
      groups: [
        'GetAllGroupedRegionsResponse.Groups.GroupedRegion',
        {
          id: '$.ID',
          regionGroupId: '$.RegionGroupID',
          regionId: '$.RegionID'
        }
      ]
    }
  });

  cleanUpResponse(response);

  return response.groups;
}
